import { Mediator, app, payload, eData } from "modular-openscriptjs";
import {
	eParse,
	inform,
	processStart,
	processEnd,
	approved,
	empty,
} from "../helpers";
import { analyze } from "../analytics";
import { STRINGS, api, uc, dc, gc } from "../declarations";
import { routes } from "../backendRoutes";

const $e = app("$e");

export class Product extends Mediator {
	$$product = {
		needs: {
			storage: (ed, event) => {
				this.saveProduct(ed, event);
			},
		},
	};

	async deleteProduct(ed, __event) {
		if (!approved(__event, ed, "You want to delete this product")) return;

		let data = eParse(ed);

		let res = await api.delete(
			`${routes.products}/${data.message.id}`
		);

		if (!res) return this.broadcast($e.product.has.deletionError, ed);

		inform(res.message, STRINGS.SUCCESS);

		data.message.put("productId", res.data.id);

		return this.broadcast($e.product.deleted, data.encode());
	}
}
